/* global localStorage */
import PropTypes from 'prop-types'
import React from 'react'
import { observer, inject } from 'mobx-react'
import ListStore from 'react-mobx-admin/state/data_table'
import {
  Button,
  ButtonGroup,
  Modal,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'

const RegionFilter = ({ store }) => {
  const regionModal = () => {
    store.regionFilterOpened = true
    let lastChar = ''
    const countries = store.options && store.options.has('Countries') &&
      store.options.get('Countries').filter(i => i.value.length <= 2)
    const mapCountries = (i, firstChar = false) => {
      if (firstChar && lastChar !== firstChar) {
        lastChar = firstChar
      } else {
        firstChar = false
      }
      return (
        <span key={i.value} title={i.value}>
          {firstChar ? <div><h6><strong>{firstChar}</strong></h6></div> : ''}
          {store.regionFilterValue && store.regionFilterValue === i.value
            ? <strong className='btn btn-success btn-sm'>{i.text}</strong>
            : <a className='btn btn-default btn-sm' href='javascript:void(0);'
              onClick={() => store.regionFilterUpdate(i.value)}>{i.text}</a>
          }{' '}
        </span>
      )
    }
    const regionFilterHistory = localStorage && localStorage.getItem('regionFilterHistory') && localStorage.getItem('regionFilterHistory').length
      ? localStorage.getItem('regionFilterHistory').split(',')
      : []

    return !countries ? null : (
      <Modal show backdrop='static' onHide={() => store.regionFilterModalOpen(false)} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>{store.__('Select a global region filter')}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ lineHeight: '2.7em', textAlign: 'left' }}>
          <div><h5>{store.__('Recently used')}</h5></div>
          {regionFilterHistory.push('WW') && regionFilterHistory.reverse().map(j => {
            const i = countries.find(c => c.value === j)
            return mapCountries(i)
          })}
          <hr />
          <div><h5>{store.__('All regions')}</h5></div>
          {countries.map((i) => {
            return mapCountries(i, i.text && i.text[0])
          })}
        </Modal.Body>
        <Modal.Footer>
          <div className='btn-group' role='group'>
            <Button bsStyle='default' onClick={() => store.regionFilterModalOpen(false)}>
              <span className='glyphicon glyphicon-remove' />&nbsp;
              {store.__('Close')}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }

  return (
    <ButtonGroup className='btn-group-top-right'>
      {store.regionFilterValue &&
        <OverlayTrigger placement='top' overlay={<Tooltip>{store.__('Remove region filter')}</Tooltip>}>
          <Button bsStyle='default' onClick={() => store.regionFilterUpdate()}>{' X '}</Button>
        </OverlayTrigger>
      }
      <OverlayTrigger placement='top' overlay={<Tooltip>{store.__('Click to set the global region filter')}</Tooltip>}>
        <Button
          bsStyle={store.regionFilterValue ? 'success' : 'default'}
          onClick={() => store.regionFilterModalOpen()}>
          <i className='glyphicon glyphicon-globe' />&nbsp;
          {store.regionFilterValue || store.__('Region')}
        </Button>
      </OverlayTrigger>
      {(store.regionFilterModal && !store.regionFilterOpened) && regionModal()}
    </ButtonGroup>
  )
}
RegionFilter.propTypes = {
  store: PropTypes.instanceOf(ListStore).isRequired
}

export default inject('store')(observer(RegionFilter))
